<div>
  <div class="title">
    <h2 class="primary" i18n="@@Create Project Folder">Create Project Folder</h2>
  </div>
  <div>
    <form [formGroup]="changeForm" (change)="formChanged()">
      <app-folder-path [path]="selectedFolder"><ng-container i18n="@@Parent folder">Parent folder</ng-container></app-folder-path>
      <div class="text-inside">
        <mat-form-field class="full-width">
          <mat-label i18n="@@Folder Name">Folder Name</mat-label>
          <input formControlName="newFolderName" matInput i18n-placeholder="@@Folder Name" placeholder="Folder Name" type="text" name="first-name" (input)="update()" (blur)="update()" (change)="update()" required/>
        </mat-form-field>
      </div>
      <div class="folderError" *ngIf="errorMessage" i18n="@@A folder with that name already exists here.">A folder with that name already exists here.</div>
      <div class="btn-sec">
        <button mat-raised-button type="button" class="Discard-btn" mat-dialog-close="" i18n="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel">Cancel</button>
        <button mat-raised-button type="submit" color="primary" class="Update-btn" [disabled]="changeForm.invalid || !validFolderName" [title]="folderNameLabel" (click)="onChange()"><span i18n="@@Create Folder">Create Folder</span><ng-container *ngIf="folderNameLabel">&nbsp;"{{ folderNameLabel }}"</ng-container></button>
      </div>
    </form>
  </div>
</div>
